module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "p-2 space-y-3"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "bouteille"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v("Régularisation")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: " !m-0 pb-6",
    attrs: {
      "back": {
        name: 'bouteille',
        params: {
          id: _vm.bouteille.id
        }
      }
    }
  })], 1)]), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-lg overflow-hidden mb-24"
  }, [_c('div', {
    staticClass: "bg-white p-4"
  }, [_c('form', {
    staticClass: "space-y-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('h2', {
    staticClass: "text-lg font-bold text-secondary mb-4"
  }, [_vm._v("\n                        QUANTITÉ ACTUELLE : " + _vm._s(_vm.bouteille.poids_net) + " / " + _vm._s(_vm.bouteille.poids_max) + " Kg\n                    ")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type de régularisation "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.type),
      expression: "op.type",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "hidden",
    attrs: {
      "id": "type-ajout",
      "type": "radio",
      "name": "type",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.op.type, _vm._n("6"))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.op, "type", _vm._n("6"))
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex items-center justify-center gap-2 h-12 rounded-lg border-2 transition-all cursor-pointer",
    class: _vm.op.type === 6 ? 'bg-secondary text-white border-secondary' : 'bg-gray-100 text-gray-600 border-gray-300 hover:border-gray-400',
    attrs: {
      "for": "type-ajout"
    }
  }, [_c('span', [_vm._v("Ajout")]), _vm._v(" "), (_vm.op.type === 6) ? _c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-check bg-white"
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.type),
      expression: "op.type",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "hidden",
    attrs: {
      "id": "type-retrait",
      "type": "radio",
      "name": "type",
      "value": "7"
    },
    domProps: {
      "checked": _vm._q(_vm.op.type, _vm._n("7"))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.op, "type", _vm._n("7"))
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex items-center justify-center gap-2 h-12 rounded-lg border-2 transition-all cursor-pointer",
    class: _vm.op.type === 7 ? 'bg-secondary text-white border-secondary' : 'bg-gray-100 text-gray-600 border-gray-300 hover:border-gray-400',
    attrs: {
      "for": "type-retrait"
    }
  }, [_c('span', [_vm._v("Retrait")]), _vm._v(" "), (_vm.op.type === 7) ? _c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-check bg-white"
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("\n                            Quantité corrigée "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.op.quantity),
      expression: "op.quantity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "0.001",
      "min": "0",
      "id": "quantity"
    },
    domProps: {
      "value": (_vm.op.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.op, "quantity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Commentaire "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.op.comment),
      expression: "op.comment"
    }],
    staticClass: "input min-h-[100px] resize-y",
    attrs: {
      "name": "comment",
      "id": "comment",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.op.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.op, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "w-full bg-primary text-white font-semibold tracking-wide px-5 py-3 rounded-xl shadow hover:shadow-md active:scale-[0.99] transition",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        Valider\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0980add1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/BouteilleRegul.vue
// module id = 1001
// module chunks = 0